import type {
  KgInsight,
  KgInsightGeoSentiment,
  KgInsightTakeawayTag,
  KgInsightThemeType,
} from '@api';
import type { BadgeColor } from '@design';

import sharedStyles from './kg-insight-constants.module.scss';

export type ThemeColor = 'indigo' | 'teal' | 'purple' | 'gold';

export type Sentiment = KgInsight['sentiment'];

export const SENTIMENT_BADGE_COLOR: Record<Sentiment, BadgeColor> = {
  positive: 'success',
  negative: 'error',
  neutral: 'warning',
};

export const GEO_SENTIMENT_BADGE_COLOR: Record<
  KgInsightGeoSentiment,
  BadgeColor
> = {
  positive: 'success',
  negative: 'error',
  warning: 'warning',
  mixed: 'neutral',
};

export const GEO_SENTIMENT_LINEAR_GRADIENT_STYLE_MAP: Record<
  KgInsightGeoSentiment,
  string
> = {
  positive: sharedStyles.cardPositive,
  negative: sharedStyles.cardNegative,
  warning: sharedStyles.cardWarning,
  mixed: sharedStyles.cardWarning,
};

export const SENTIMENT_STYLE_MAP: Record<Sentiment, string> = {
  positive: 'bullish',
  negative: 'bearish',
  neutral: 'warning',
};

export type ThemeTagType = 'industry_theme' | 'financial_theme' | 'macro_theme';

export const THEME_TAG_KIND_MAP: Record<
  KgInsightTakeawayTag['kind'],
  ThemeColor
> = {
  industry: 'indigo',
  financial: 'purple',
  macro: 'teal',
};

export const THEME_TAG_COLOR_CLASS_MAP: Record<KgInsightThemeType, string> = {
  industry: sharedStyles.themeTextIndigo,
  financial: sharedStyles.themeTextPurple,
  macro: sharedStyles.themeTextTeal,
};

export const THEME_FILL_COLOR_CLASS_MAP: Record<KgInsightThemeType, string> = {
  industry: sharedStyles.themeFillIndustry,
  financial: sharedStyles.themeFillFinancial,
  macro: sharedStyles.themeFillMacro,
};
